import { fetchUserDetailsFail, fetchUserDetailsSuccess } from './actions';
import { put } from 'redux-saga/effects';
import { makeErrorPayload } from '../../../../../../shared/helpers/payload.helper';
import { setErrorToast } from '../../../../../../shared/toast/redux/actions';
import { getUserById } from '../user.backend';

export function* fetchUserDetailsSaga(action) {
    try {
        const response = yield getUserById(action.payload);
        yield put(fetchUserDetailsSuccess(response.data));
    } catch (error) {
        const formattedError = makeErrorPayload(error);

        yield put(fetchUserDetailsFail(formattedError));
        yield put(setErrorToast(formattedError));
    }
}
